var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { md: "3" } },
            [
              _c(
                "b-form-group",
                {
                  attrs: {
                    label: _vm.$t("systematic_intimidation.protocol_number"),
                    "label-for": "protocol"
                  }
                },
                [
                  _c("b-form-input", {
                    attrs: {
                      id: "protocol",
                      value: _vm._.get(_vm.requestForm, "form.protocol_number"),
                      readonly: ""
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "b-col",
            { attrs: { md: "3" } },
            [
              _c(
                "b-form-group",
                {
                  attrs: {
                    label: _vm.$t("systematic_intimidation.created_at"),
                    "label-for": "created_at"
                  }
                },
                [
                  _c("b-form-input", {
                    attrs: {
                      id: "created_at",
                      value: _vm._.get(
                        _vm.requestForm,
                        "form.created_date_formatted"
                      ),
                      readonly: ""
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "b-col",
            {
              staticClass: "content-center content-center",
              attrs: { md: "3" }
            },
            [
              _c("NavigationOriginPopup", {
                attrs: { navigationField: _vm.navigationField }
              })
            ],
            1
          ),
          _c(
            "b-col",
            {
              staticClass: "content-center content-center",
              attrs: { md: "3" }
            },
            [
              _c("ProtocolQueryHistoryPopup", {
                attrs: {
                  protocol_number: _vm._.get(
                    _vm.requestForm,
                    "form.protocol_number"
                  ),
                  type: "systematic-intimidation"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "b-row",
        { attrs: { md: "12" } },
        [
          _c(
            "b-col",
            [
              _c(
                "b-form-group",
                {
                  attrs: {
                    label: _vm.$t("systematic_intimidation.institution_unity"),
                    "label-for": "link"
                  }
                },
                [
                  _c("b-form-input", {
                    attrs: {
                      id: "link",
                      value: _vm._.get(
                        _vm.requestForm,
                        "form.legal_entity_name"
                      ),
                      readonly: ""
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "b-row",
        { attrs: { md: "12" } },
        [
          _c(
            "b-col",
            [
              _c(
                "b-form-group",
                {
                  attrs: {
                    label: _vm.$t("systematic_intimidation.link_profile"),
                    "label-for": "link"
                  }
                },
                [
                  _c("b-form-input", {
                    attrs: {
                      id: "link",
                      value: _vm._.get(_vm.requestForm, "form.link"),
                      readonly: ""
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { md: "12" } },
            [
              _c("b-form-group", {
                attrs: {
                  label: _vm.$t("systematic_intimidation.description"),
                  "label-for": "description"
                }
              }),
              _c("b-form-textarea", {
                attrs: {
                  id: "description",
                  value: _vm._.get(_vm.requestForm, "form.description"),
                  rows: "4",
                  readonly: ""
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "b-row",
        { staticClass: "m-0" },
        [
          _c(
            "b-col",
            { attrs: { lg: "12" } },
            [
              _c("h5", { staticClass: "mt-2 mb-0" }, [
                _vm._v(_vm._s(_vm.$t("systematic_intimidation.handling")))
              ]),
              _c("vs-divider")
            ],
            1
          )
        ],
        1
      ),
      _c(
        "b-row",
        { staticClass: "m-0" },
        [
          _c(
            "b-col",
            { attrs: { lg: "4" } },
            [
              _c(
                "b-form-group",
                {
                  attrs: {
                    label: _vm.$t("systematic_intimidation.status"),
                    "label-for": "status"
                  }
                },
                [
                  _c("b-form-input", {
                    attrs: {
                      id: "status",
                      value: _vm._.get(_vm.requestForm, "status_str"),
                      readonly: ""
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "b-col",
            { attrs: { lg: "8" } },
            [
              _c("HandlingHistoryPopup", {
                attrs: { id: _vm.id, serviceDelegate: _vm.services.handling }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }